import { render, staticRenderFns } from "./MassenKorrespondenzEmpfaengerAbsender.vue?vue&type=template&id=00733aa3&"
import script from "./MassenKorrespondenzEmpfaengerAbsender.vue?vue&type=script&lang=js&"
export * from "./MassenKorrespondenzEmpfaengerAbsender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports